export const ROLES = {
    SUPER_USER: 'SUPERUSER',
    ADMIN: 'ADMIN',
    GENERAL: 'GENERAL',
    USER: 'USER',
}

export default { ROLES }
